import React from "react";
import { Box, Typography } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Box className="container-sm" sx={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom style={{ color: "#495057" }}>
        Privacy Policy
      </Typography>

      <Typography variant="p" paragraph>
        (“us”, “we”, or “our”) operates the website and the Sastraprakasika
        Trust mobile application (the “Service”).
      </Typography>
      <Typography variant="p" paragraph>
        This page informs you of our policies regarding the collection, use, and
        disclosure of personal data when you use our Service and the choices you
        have associated with that data. Our Privacy Policy for Sastraprakasika
        Trust is managed through
      </Typography>
      <Typography variant="p" paragraph>
        We use your data to provide and improve the Service. By using the
        Service, you agree to the collection and use of information in
        accordance with this policy. Unless otherwise defined in this Privacy
        Policy, terms used in this Privacy Policy have the same meanings as in
        our Terms and Conditions.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Information Collection And Use
      </Typography>
      <Typography variant="p" paragraph>
        We collect several different types of information for various purposes
        to provide and improve our Service to you.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Types of Data Collected
      </Typography>
      <Typography variant="h6" gutterBottom style={{ color: "#495057" }}>
        Personal Data
      </Typography>
      <Typography variant="p" paragraph>
        While using our Service, we may ask you to provide us with certain
        personally identifiable information that can be used to contact or
        identify you (“Personal Data”). Personally identifiable information may
        include, but is not limited to:
        <br /> <br />
        Email address <br /> First name and last name <br /> Phone number <br />{" "}
        Cookies and Usage Data
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Usage Data
      </Typography>
      <Typography variant="p" paragraph>
        We may also collect information that your browser sends whenever you
        visit our Service or when you access the Service by or through a mobile
        device (“Usage Data”).
      </Typography>
      <Typography variant="p" paragraph>
        This Usage Data may include information such as your computer’s Internet
        Protocol address (e.g. IP address), browser type, browser version, the
        pages of our Service that you visit, the time and date of your visit,
        the time spent on those pages, unique device identifiers and other
        diagnostic data.
      </Typography>
      <Typography variant="p" paragraph>
        When you access the Service by or through a mobile device, this Usage
        Data may include information such as the type of mobile device you use,
        your mobile device unique ID, the IP address of your mobile device, your
        mobile operating system, the type of mobile Internet browser you use,
        unique device identifiers and other diagnostic data.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Tracking & Cookies Data
      </Typography>
      <Typography variant="p" paragraph>
        We use cookies and similar tracking technologies to track the activity
        on our Service and hold certain information.
        <br />
        <br />
        Cookies are files with small amount of data which may include an
        anonymous unique identifier. Cookies are sent to your browser from a
        website and stored on your device. Tracking technologies also used are
        beacons, tags, and scripts to collect and track information and to
        improve and analyze our Service.
        <br />
        <br />
        You can instruct your browser to refuse all cookies or to indicate when
        a cookie is being sent. However, if you do not accept cookies, you may
        not be able to use some portions of our Service.
        <br />
        <br />
        Examples of Cookies we use:
        <br />
        Session Cookies. We use Session Cookies to operate our Service.
        <br />
        Preference Cookies. We use Preference Cookies to remember your
        preferences and various settings.
        <br />
        Security Cookies. We use Security Cookies for security purposes.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Use of Data
      </Typography>
      <Typography variant="p" paragraph>
        Sastraprakasika Trust uses the collected data for various purposes:
        <br />
      </Typography>
      <Typography variant="p" paragraph>
        To provide and maintain the Service To notify you about changes to our
        <br />
        Service To allow you to participate in interactive features of our
        <br />
        Service when you choose to do so To provide customer care and support To
        <br />
        provide analysis or valuable information so that we can improve the
        <br />
        Service To monitor the usage of the Service To detect, prevent and
        address technical issues
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Transfer Of Data
      </Typography>
      <Typography variant="p" paragraph>
        Your information, including Personal Data, may be transferred to — and
        maintained on — computers located outside of your state, province,
        country or other governmental jurisdiction where the data protection
        laws may differ than those from your jurisdiction.
        <br />
        <br />
        If you are located outside India and choose to provide information to
        us, please note that we transfer the data, including Personal Data, to
        India and process it there.
        <br />
        <br />
        Your consent to this Privacy Policy followed by your submission of such
        information represents your agreement to that transfer.
        <br />
        <br />
        Sastraprakasika Trust will take all steps reasonably necessary to ensure
        that your data is treated securely and in accordance with this Privacy
        Policy and no transfer of your Personal Data will take place to an
        organization or a country unless there are adequate controls in place
        including the security of your data and other personal information.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Disclosure Of Data
      </Typography>
      <Typography variant="h6" gutterBottom style={{ color: "#495057" }}>
        Legal Requirements
      </Typography>
      <Typography variant="p" paragraph>
        Sastraprakasika Trust may disclose your Personal Data in the good faith
        belief that such action is necessary to:
        <br />
        <br />
        To comply with a legal obligation
        <br />
        To protect and defend the rights or property of Sastraprakasika Trust
        <br />
        To prevent or investigate possible wrongdoing in connection with the
        Service
        <br />
        To protect the personal safety of users of the Service or the public
        <br />
        To protect against legal liability
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Security Of Data
      </Typography>
      <Typography variant="p" paragraph>
        The security of your data is important to us, but remember that no
        method of transmission over the Internet, or method of electronic
        storage is 100% secure. While we strive to use commercially acceptable
        means to protect your Personal Data, we cannot guarantee its absolute
        security.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Security Service Providers
      </Typography>
      <Typography variant="p" paragraph>
        We may employ third party companies and individuals to facilitate our
        Service (“Service Providers”), to provide the Service on our behalf, to
        perform Service-related services or to assist us in analyzing how our
        Service is used.
        <br />
        <br />
        These third parties have access to your Personal Data only to perform
        these tasks on our behalf and are obligated not to disclose or use it
        for any other purpose.
      </Typography>
      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Analytics
      </Typography>
      <Typography variant="p" paragraph>
        We may use third-party Service Providers to monitor and analyze the use
        of our Service.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Google Analytics
      </Typography>
      <Typography variant="p" paragraph>
        Google Analytics is a web analytics service offered by Google that
        tracks and reports website traffic. Google uses the data collected to
        track and monitor the use of our Service. This data is shared with other
        Google services. Google may use the collected data to contextualize and
        personalize the ads of its own advertising network.
      </Typography>
      <Typography variant="p" paragraph>
        For more information on the privacy practices of Google, please visit
        the Google Privacy & Terms web page:{" "}
        <a
          href="https://policies.google.com/privacy?hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://policies.google.com/privacy?hl=en
        </a>
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Links To Other Sites
      </Typography>
      <Typography variant="p" paragraph>
        Our Service may contain links to other sites that are not operated by
        us. If you click on a third-party link, you will be directed to that
        third party’s site. We strongly advise you to review the Privacy Policy
        of every site you visit.
      </Typography>
      <Typography variant="p" paragraph>
        We have no control over and assume no responsibility for the content,
        privacy policies, or practices of any third-party sites or services.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Changes To This Privacy Policy
      </Typography>
      <Typography variant="p" paragraph>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page.
      </Typography>
      <Typography variant="p" paragraph>
        We will let you know via email and/or a prominent notice on our Service,
        prior to the change becoming effective and update the “effective date”
        at the top of this Privacy Policy.
      </Typography>
      <Typography variant="p" paragraph>
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Copyright
      </Typography>
      <Typography variant="p" paragraph>
        All the lectures available in this Sastraprakasika App are copyright of
        Vedanta Vidyarthi Sangha
      </Typography>
      <Typography variant="p" paragraph>
        © Vedanta Vidyarthi Sangha All rights reserved
      </Typography>
      <Typography variant="p" paragraph>
        Recorded & Digitally Mastered By Mantra/Yogamalika LLC
      </Typography>
      <Typography variant="p" paragraph>
        Terms & conditions and user Licenses of the discourse by Swami
        Paramarthananda in this App.
      </Typography>
      <Typography variant="p" paragraph>
        Your purchase is for a single-user License for self-study only.
      </Typography>
      <Typography variant="p" paragraph>
        Duplicating, copying, sharing; or posting in any form/Channel including
        free, commercial, non-profit, personal, websites, Apps and social media
        is not permitted and violates the copyright of Vedanta Vidyarthi Sangha.
      </Typography>
      <Typography variant="p" paragraph>
        Kindly report any violation to{" "}
        <a href="mailto:mantraglobus@gmail.com">mantraglobus@gmail.com</a>
      </Typography>

      <Typography variant="h5" gutterBottom style={{ color: "#495057" }}>
        Contact Us
      </Typography>
      <Typography variant="p" paragraph>
        If you have any questions about this Privacy Policy, please contact us:
      </Typography>
      <Typography variant="p" paragraph>
        By email:{" "}
        <a href="mailto:sastraprakasika@gmail.com">sastraprakasika@gmail.com</a>
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
